<i18n>
{
  "no": {
    "verificationCode": "Bekreftelseskode (6 siffer)"
  },
  "en": {
    "verificationCode": "Verification code (6 digits)"
  }
}
</i18n>

<template>
  <div class="code-form">
    <TnTextField
      v-model="code"
      name="code"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="6"
      pattern="[0-9]*"
      :label="t('verificationCode')"
    />

    <TnButton type="submit" primary block class="margin-top-m" icon-right="cta-right" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TnButton, TnTextField } from '@telenornorgeinternal/telegrafen-vue3-core';

// Was a `verificationCode` object prop mutated in place by v-model; now a
// proper two-way binding on the code itself.
const code = defineModel<string>({ default: '' });

const { t } = useI18n();
</script>

<style scoped>
.code-form {
  max-width: 430px;
  margin-inline: auto;
}
</style>
